/*
 * @Descripttion:盲盒商城商品订单
 * @Author: lc
 * @Date: 2021-10-25 08:33:06
 * @LastEditors: lc
 * @LastEditTime: 2024-12-13 14:23:02
 */
import axios from '../.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const goodorder = {
    //支付订单列表
    payorderlist (params) {
        return axios.get(api + 'mangheshopgoodorder/payorderlist', { params: params })
    },
    //关闭
    closepayorder (params) {
        return axios.post(api + 'mangheshopgoodorder/closepayorder', qs.stringify(params))
    },
    //获取编辑信息
    detail (params) {
        return axios.get(api + 'mangheshopgoodorder/detail', { params: params })
    },
    //关闭
    close (params) {
        return axios.post(api + 'mangheshopgoodorder/close', qs.stringify(params))
    },
    exportpayorder (params) {
        return axios.post(api + 'mangheshopgoodorder/exportpayorder', qs.stringify(params))
    },
}


// 导出接口
export default goodorder



